import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo } from 'react';
import { FormField } from '@wit-support/ui';
import { AdsTargetingDataProvider, } from '@wit-support/ui-domain';
import { useInterestSearch, useUsedInterests } from '../queries.js';
/** Оболочка поля для виджетов таргетинга в «Кампаниях»: подпись, пояснение, ошибка (без react-hook-form). */
const LiveFieldShell = ({ meta, label, description, hint, htmlFor, fieldState, children, }) => {
    const resolvedLabel = label ?? meta.label;
    const resolvedDescription = description ?? meta.description ?? hint ?? meta.hint;
    const error = fieldState.error?.message;
    return (_jsxs(FormField, { children: [resolvedLabel ? _jsx(FormField.Label, { htmlFor: htmlFor, children: resolvedLabel }) : null, _jsx(FormField.Control, { children: children }), resolvedDescription ? (_jsx(FormField.Description, { children: resolvedDescription })) : null, error ? _jsx(FormField.Error, { children: error }) : null] }));
};
/** Данные виджетов таргетинга для «Кампаний»: запросы интересов — через admin-api этого модуля. */
export function LiveTargetingProvider({ platformAccountId, children, }) {
    const value = useMemo(() => ({
        platformAccountId,
        // списки стран «Кампании» разворачивают на клиенте сами (кнопка «Добавить из списка стран»)
        countryLists: null,
        audienceSlotNames: null,
        useUsedInterests,
        useInterestSearch,
        FieldShell: LiveFieldShell,
    }), [platformAccountId]);
    return _jsx(AdsTargetingDataProvider, { value: value, children: children });
}
//# sourceMappingURL=targeting-data.js.map